import {
  PropertiesByArea,
  FeaturedPropertiesArea,
  CallToAction,
  AreasMap,
  VideoArea,
  SearchForm,
  SlideItem,
} from './components';
import { useState } from 'react';
import { heroClips } from './heroClips.ts';

export const Home = () => {
  const [area, setArea] = useState<string>('');
  const handleAreaChange = (a: string) => {
    setArea(a);
  };

  return (
    <>
      <VideoArea clips={heroClips}>
        <SlideItem alignment='text-center' />
      </VideoArea>
      <SearchForm area={area} setArea={handleAreaChange} />
      <AreasMap area={area} setArea={handleAreaChange} />
      <PropertiesByArea />
      <FeaturedPropertiesArea />
      <CallToAction />
    </>
  );
};
